import React from "react";
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
    Typography,
    Pagination,
    Box,
    Grid,
} from "@mui/material";
import DownloadIcon1 from "@mui/icons-material/Download";
import PayinReportInvoice from "../PayinReportInvoice";
import html2pdf from "html2pdf.js";
import PayinLocalInvoice from "../LocalInvoices/PayinLocalInvoice";



const PayInTable = ({ filteredData, classes = {}, message, page, pageSize, currentPage }) => {
      const userType = sessionStorage.getItem("uType");


    const handleDownloadInvoice = async (data) => {
        const receiptElement = document.getElementById(`receipt-${data.txnid}`);

        if (!receiptElement) {
        console.error("Receipt element not found:", `receipt-${data.txnid}`);
        return;
        }

        const opt = {
        margin: [0.5, 0.5, 0.5, 0.5], // top, left, bottom, right in inches
        filename: `Payin Receipt-${data.txnid}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
            unit: "in",
            orientation: "landscape",
            format: "a4",
            margin: 0.5,
        },
        };

        try {
        await html2pdf().from(receiptElement).set(opt).save();
        } catch (error) {
        console.error("Error generating PDF: ", error);
        }
    };

    if (message) {
        return <Typography variant="h6" align="center">{message}</Typography>;
    }

    return (
        <Box>
            <TableContainer
                component={Paper}
                sx={{
                    maxWidth: "100%",
                    overflowX: "auto",
                    borderRadius: "12px",
                    boxShadow: "none",
                    marginTop:"1%",
                }}
            >
                <Table>
                    <TableHead>
                    <TableRow sx={{ backgroundColor: "#027BFE" }}>
                    {[
                        "Sr. No.",
                        "Txn ID",
                        "UTR No",
                        "Date",
                        "PayIn Amount",
                        "Amount",
                        "Status",
                        "Invoice",
                    ].map((header) => (
                        <TableCell key={header} sx={{ color: "white", fontWeight: "bold" }}>
                        {header}
                        </TableCell>
                    ))}
                    </TableRow>

                    </TableHead>
                    <TableBody>
                        {filteredData.length > 0 ? (
                            filteredData.map((row, index) => (
                                <TableRow
                                    key={row.txnid}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#D0EFFF",
                                    }}
                                >
                                    <TableCell>{currentPage * pageSize + index + 1}</TableCell>
                                    <TableCell>{row.txnid}</TableCell>
                                    <TableCell>{row.easepayid}</TableCell>
                                    <TableCell>{row.addedon}</TableCell>
                                    <TableCell>{row.netAmountDebit || "N/A"}</TableCell>
                                    <TableCell>{row.amount}</TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            color:
                                                row.status === "success"
                                                    ? "green"
                                                    : row.status === "failure"
                                                        ? "red"
                                                        : "black",
                                        }}
                                    >
                                        {row.status === "success" ? "Successful" : "Failed"}
                                    </TableCell>
                                    {/* {userType !== "RETAILER" && userType !== "AREADISTRIBUTOR" && ( */}
                                    <TableCell align="center">
                                    <DownloadIcon1
                                        onClick={() => handleDownloadInvoice(row)}
                                        style={{ cursor: "pointer" }}
                                    />
                                    </TableCell>
                                    {/* )} */}
                                    <Grid
                                        style={{
                                        position: "absolute",
                                        left: "-9999px",
                                        top: "0px",
                                        }}
                                    >
                                        <Grid id={`receipt-${row.txnid}`}>
                                        {/* <PayinReportInvoice data={row} /> this is official invoice */}
                                        <PayinLocalInvoice data={row} />
                                        </Grid>
                                    </Grid>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={7} align="center">
                                    No Data Available
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};


export default PayInTable;
